import { Node } from "@tiptap/core";
export interface CollapsableHeadingOptions {
  HTMLAttributes: Record<string, unknown>;
}

interface CollapsableHeadingsReturnType {
  defaultOpen: boolean;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    collapsableHeading: {
      toggleCollapsableHeading: (
        attributes: CollapsableHeadingsReturnType
      ) => ReturnType;
    };
  }
}

export const defaultOpenAttributeValue = "default-open";
export const defaultClosedAttributeValue = "default-closed";

export const CollapsableHeading = Node.create<CollapsableHeadingOptions>({
  name: "collapsableHeading",

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  content: "inline*",

  group: "block",

  defining: true,

  addCommands() {
    return {
      toggleCollapsableHeading:
        (attributes) =>
        ({ commands }) => {
          // This ensures that collapsible headings are only available for headings on level 2.
          if (!this.editor.isActive("heading", { level: 2 })) {
            return false;
          }

          let targetAttributeValue = defaultClosedAttributeValue;

          if (attributes.defaultOpen) {
            targetAttributeValue = defaultOpenAttributeValue;
          }

          const nodeAttributes = this.editor.getAttributes("heading");

          const newAttributes: Record<string, unknown> = {};

          if (nodeAttributes["data-collapsable"] !== targetAttributeValue) {
            newAttributes["data-collapsable"] = targetAttributeValue;
          } else {
            newAttributes["data-collapsable"] = null;
          }

          return commands.updateAttributes("heading", newAttributes);
        },
    };
  },
});
